module.exports = __webpack_public_path__ + "img/location.d677139f.svg";